import GlobalStyle from "../../constants/GlobalStyle";
import { Box, RadioInput, SegmentedButton, Stack , Text} from "../DesignSystem";
import { useContext, useReducer, useState } from "react";
import CustomAmountInput from "../../screens/Checkout/Components/CutomAmountInput";
type Props = {
  title?: string;
  description?: string;
  presentValues: { value: number; label: string; disabled: boolean }[];
  hasCustomValue: boolean;
  onChange: (e: { value: number; label: string } | null) => void;
  presentLabel?: string;
  presentDescription?: string;
  customLabel?: string;
  customDescription?: string;
  selectedAmount: number;
};
const AmountPicker: React.FC<Props> = ({
  presentValues,
  presentLabel,
  customLabel,
  onChange,
  selectedAmount,
  hasCustomValue,
  customDescription,
  title,
  description,
}) => {
  const [presetRadioOn, setPresetRadioOn] = useState<boolean | null>(true);

  return (
    <Box style={{ marginHorizontal: 0 }}>
      {title && (
        <Text
          style={[
            GlobalStyle.subHeaderText,
            { marginTop: 15, marginBottom: 30, textAlign: "left" },
          ]}
        >
          {title}
        </Text>
      )}
      {description && (
        <Text style={[{ marginTop: 15, marginBottom: 30, textAlign: "left" }]}>
          {description}
        </Text>
      )}
      <Stack gap="xxl" align="left">
        <Stack gap="sm">
          <RadioInput
            label={presentLabel || "Preset"}
            selected={presetRadioOn}
            onPress={() => {
              setPresetRadioOn(true);
              onChange?.(null);
            }}
          />

          <SegmentedButton
            options={presentValues}
            selectedValue={Number(selectedAmount)}
            onSelect={(e) => {
              onChange(e);
            }}
            size="md"
            buttonStyle={{
              paddingVertical: global.kiosk && 16,
            }}
          />
        </Stack>
        {hasCustomValue && (
          <Stack gap="sm" align="left">
            <RadioInput
              label={customLabel || "Custom"}
              selected={presetRadioOn === false}
              onPress={() => {
                setPresetRadioOn(false);
                onChange?.(null);
              }}
            />
            <Text style={[GlobalStyle.tipText]}>{customDescription}</Text>
            <Box style={{ maxWidth: 160 }}>
              <CustomAmountInput
                amount={selectedAmount}
                setAmount={(value) => {
                    onChange({value: value * 100,label: value.toString()});
                }}
                onFocus={() => setPresetRadioOn(false)}
              />
            </Box>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default AmountPicker;
